/**
 * 基础DTO类型定义
 * 参考后端 dto.go 的结构设计
 */
// 导入 ForgeQuery 类型
import type { ForgeQuery } from '../components/ForgeQueryBuilder/types';

// 分页常量
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

// 分页请求结构 - 基于 ForgeQuery
export interface PaginationRequest<F = any> extends ForgeQuery<F> {
  // ForgeQuery 已包含 page, pageSize, filter, sort
  // 这里可以添加额外的分页相关字段
}

// 分页信息
export interface PaginationInfo {
  page: number;         // 当前页码
  page_size: number;    // 每页大小
  total: number;        // 总记录数
  total_pages: number;  // 总页数
}

// 通用列表响应结构（泛型）
export interface ListResponse<T> {
  items: T[];                    // 数据项列表
  pagination: PaginationInfo;    // 分页信息
}

// 统一响应结构（泛型）
export interface BaseResponse<T = any> {
  code: number;      // 响应状态码
  message: string;   // 响应消息
  data: T;          // 响应数据
}

// ID请求参数（用于获取、更新、删除等操作）
export interface IDRequest {
  id: string;
}

export interface StoreDiffRowEntity {
  date: string;
  store_id: string;
  value: number;
}
